import { useSelector } from "react-redux";
import PreviewActions from "../../../viewer/common/PreviewActions.tsx";
import ViewContainer from "../../../viewer/common/ViewContainer.tsx";
import ViewerParameters from "../../../viewer/common/ViewerParameters.tsx";
import type { TileRunState } from "../../../viewer/storage/runState.ts";
import useRequestConfigViewer from "../../../viewer/tile/hooks/useRequestConfigViewer.ts";
import useTileDataViewer from "../../../viewer/tile/hooks/useTileDataViewer.tsx";
import PreviewComponent from "../../../viewer/tile/PreviewComponent.tsx";
import { useBiCommonDataContext } from "../../../../contexts/BiCommonDataContext.ts";
import biApi from "../../../../../../../../api/biApi";
import { selectSessionId } from "../../../../store/selectors/currentReportSelectors";
import { selectLogQueries } from "../../../../store/selectors/devToolsSelectors";
import useCommonReportHandlers from "../../common/hooks/useCommonReportHandlers";

interface Props {
  runState: TileRunState;
}

export default function TileViewer({ runState }: Props) {
  const { onRefreshGrid } = useBiCommonDataContext();
  const sessionId = useSelector(selectSessionId);
  const isQueryLoggingActive = useSelector(selectLogQueries);
  const handlers = useCommonReportHandlers(runState.fields);

  const { requestConfig } = useRequestConfigViewer({
    sessionId: sessionId,
    isQueryLoggingActive: isQueryLoggingActive,
  });

  const data = useTileDataViewer({
    requestConfig,
    runReport: biApi.uiReports.runTileReport,
    updateDevTools: handlers.updateDevTools,
    setEtag: handlers.setEtag,
    fields: runState.fields,
  });

  return (
    <ViewContainer
      Parameters={
        runState.showParameters ? (
          <ViewerParameters
            fieldsWithConditions={runState.fieldsWithCustomConditionParameters}
            initialDetailedView={runState.settings.detailedView}
          />
        ) : (
          <></>
        )
      }
      Preview={<PreviewComponent data={data} fields={runState.fields} />}
      ActionPanel={<PreviewActions onRefresh={onRefreshGrid} />}
    />
  );
}
